





















































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
import DeleteDialogComponent from "@/components/common/parts/DeleteDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { Moment } from "@/typescript/lib/common/moment";
import {
  getAlertScheduleApi,
  deleteAlertScheduleApi
} from "@/typescript/api_client/emesh_api/alert_schedules/alert_schedule_api";
import {
  GetAlertScheduleResponse,
  GetAlertSchedule
} from "@/typescript/api_client/emesh_api/alert_schedules/types";
import {
  WarningStopTimeInfo,
  WarningStopTimeSchedules
} from "@/typescript/pages/warning_stop_time/types";
export {
  Moment,
  GetAlertScheduleResponse,
  GetAlertSchedule,
  WarningStopTimeInfo,
  WarningStopTimeSchedules
};
import { getRoutePath } from "@/router/routes";

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    ButtonComponent,
    PagenationComponent,
    DeleteDialogComponent,
    FooterComponent
  }
})
export default class WarningStopTimeShowPage extends Vue {
  // スケジュール種別
  SCHEDULE_SEQUENTIAL: number = 1;
  SCHEDULE_PERIODIC: number = 2;

  // 期間種別
  TERM_WEEKLY: number = 1;
  TERM_DAILY: number = 2;
  TERM_PERIOD: number = 3;

  // 時間対象種別
  TIME_TARGET_STORE: number = 1;
  TIME_TARGET_SENSOR: number = 2;

  $refs!: {
    pagenation: PagenationComponent;
  };

  warningStopTimeInfo: WarningStopTimeInfo | {} = {};
  storeId: string = "";
  scheduleId: number = 0;
  isDeleteDialogOpen: boolean = false;
  // API 取得時の初期表示用判別フラグ
  isInitialDisplay: boolean = false;

  created() {
    this.isInitialDisplay = true;
    this.getAlertSchedule();
  }

  async getAlertSchedule() {
    const params = {
      store_id: this.$route.params["store_id"],
      start_date: this.$route.params["start_date"],
      end_date: this.$route.params["end_date"]
    };

    await getAlertScheduleApi(params).then((resp: GetAlertScheduleResponse) => {
      this.makeWarningStopTimeInfo(resp).then(resp => {
        this.warningStopTimeInfo = resp;
        this.isInitialDisplay = false;
      });
    });
  }

  async makeWarningStopTimeInfo(
    resp: GetAlertScheduleResponse
  ): Promise<WarningStopTimeInfo> {
    return {
      schedules: (await this.makeWarningStopTimeSchedules(
        resp.schedules
      )) as WarningStopTimeSchedules[]
    };
  }

  async makeWarningStopTimeSchedules(respSchedules: GetAlertSchedule[]) {
    return await Promise.all(
      respSchedules.map(async respSchedule => {
        let isSelectDaysOfWeek = new Array<boolean>(7).fill(false);
        if (respSchedule.term_type == this.TERM_WEEKLY) {
          isSelectDaysOfWeek = [
            respSchedule.sun_flg == 1 ? true : false,
            respSchedule.mon_flg == 1 ? true : false,
            respSchedule.tue_flg == 1 ? true : false,
            respSchedule.wed_flg == 1 ? true : false,
            respSchedule.thu_flg == 1 ? true : false,
            respSchedule.fri_flg == 1 ? true : false,
            respSchedule.sat_flg == 1 ? true : false
          ];
        }
        return {
          storeId: respSchedule.store_id,
          scheduleId: respSchedule.schedule_id,
          scheduleType: respSchedule.schedule_type,
          termType: respSchedule.term_type,
          startDate: respSchedule.start_date,
          endDate: respSchedule.end_date,
          isSelectDaysOfWeek: isSelectDaysOfWeek,
          timeTargetType: respSchedule.time_target_type,
          timeSchedules: respSchedule.times[0].time_schedules
        };
      })
    );
  }

  getScheduleTypeName(scheduleType: number) {
    let scheduleTypeName: string = "";
    if (scheduleType == this.SCHEDULE_SEQUENTIAL) scheduleTypeName = "逐次";
    if (scheduleType == this.SCHEDULE_PERIODIC) scheduleTypeName = "定期";
    return scheduleTypeName;
  }

  getTimeTargetTypeName(timeTargetType: number) {
    let timeTargetTypeName = "";
    if (timeTargetType == this.TIME_TARGET_STORE) timeTargetTypeName = "店舗";
    if (timeTargetType == this.TIME_TARGET_SENSOR)
      timeTargetTypeName = "センサ別";
    return timeTargetTypeName;
  }

  getTimeDateSpan(
    scheduleType: number,
    termType: number,
    startDate: string,
    endDate: string
  ) {
    let timeDateSpan = startDate;
    if (scheduleType == this.SCHEDULE_SEQUENTIAL) {
      if (termType == this.TERM_WEEKLY) {
        timeDateSpan += "週";
      } else if (termType == this.TERM_PERIOD) {
        endDate ? (timeDateSpan += "～" + endDate) : (timeDateSpan += "～");
      }
    } else if (scheduleType == this.SCHEDULE_PERIODIC) {
      endDate ? (timeDateSpan += "～" + endDate) : (timeDateSpan += "～");
    }
    return timeDateSpan;
  }

  getTimes(timeSchedules: any[]) {
    let times: string = "";
    timeSchedules.forEach(schedule => {
      times += schedule.start + "～";
      times += schedule.end + ",";
    });
    times = times.substring(0, times.length - 1);
    return times;
  }

  getDayOfWeek(index: number) {
    const daysOfWeek: string[] = ["日", "月", "火", "水", "木", "金", "土"];
    return daysOfWeek[index];
  }

  isStartDate(startDate: string) {
    let listStartDate = new Moment("YYYYMMDD", startDate).getFormatDate();
    return Number(this.$route.params["start_date"]) >= Number(listStartDate);
  }

  movePage() {
    this.$store.commit("setSensorsTabName", {
      sensorsTabName: "警報停止時間帯"
    });
    this.$router.push(
      getRoutePath("SensorsShowPage", {
        store_id: this.$route.params["store_id"]
      })
    );
  }

  openDialog(storeId: string, scheduleId: number) {
    this.storeId = storeId;
    this.scheduleId = scheduleId;
    this.isDeleteDialogOpen = true;
  }

  closeDelete() {
    this.isDeleteDialogOpen = false;
  }

  deleteData() {
    deleteAlertScheduleApi({
      store_id: this.storeId,
      schedule_id: this.scheduleId
    })
      .then(() => {})
      .catch(() => {
        alert("削除に失敗しました。");
      })
      .finally(() => {
        this.closeDelete();
        this.getAlertSchedule();
      });
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  isResult(): boolean {
    const dInfo = this.warningStopTimeInfo as WarningStopTimeInfo;
    // && を使えば一行で書けるが、コンソール上にて length 参照エラーが出るため、2 行で記述
    if (!Object.keys(dInfo).length) return true;
    if (dInfo.schedules.length <= 0) return true;
    return false;
  }
}
